import { useViewportWidth } from "@faire/web/ui/hooks/useViewportWidth";
import { RefObject, useMemo } from "react";

export const useNumHiddenTiles = (
  containerRef: RefObject<HTMLElement | null>,
  tileRef: RefObject<HTMLElement | null>,
  columnSpacingPixels: number,
  numTiles: number
) => {
  const viewportWidth = useViewportWidth((width) => width);

  const numHiddenTiles = useMemo(() => {
    const { width: containerWidth, height: containerHeight } =
      containerRef.current?.getBoundingClientRect() ?? {};
    const { width: tileWidth, height: tileHeight } =
      tileRef.current?.getBoundingClientRect() ?? {};
    if (containerWidth && containerHeight && tileWidth && tileHeight) {
      const tilesPerRow = Math.floor(
        containerWidth / (tileWidth + columnSpacingPixels)
      );
      const numRowsVisible = Math.floor(containerHeight / tileHeight);

      return numTiles - tilesPerRow * numRowsVisible;
    }

    return undefined;
    // we need to rerun this calculation if the viewport width changes
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewportWidth, columnSpacingPixels, containerRef, tileRef, numTiles]);

  return numHiddenTiles;
};
